import { createV3Queries } from "@query/utils/createV3Queries";
import { authorizationsApi } from "@api";

export const queriesAuthorizations = createV3Queries(
  "authorizationsApi",
  authorizationsApi
);
